

import type { Player, Seat } from './types.d';


// 拿取各个厅的封面图
export const fnGetCoverPics = () => {
    const oPics = import.meta.glob('../img/hall-cover/*.webp', {
        eager: true,
    });

    const aList = Object.entries(oPics).map(([key, value]) => {
        const sLongName = key.split('/').pop();
        const iPointIdx = sLongName.lastIndexOf('.');
        return [
            sLongName.slice(0, iPointIdx),
            (value as { default: any }).default,
        ];
    });

    const oResult = Object.fromEntries(aList);
    return oResult;
};

// ↓ 跳转到游戏入口页 
export const fnGoToEntrance = (
    oConfig={},
)=>{
    const path = `/casino/jisuzhajinhuaGame/entrance`; 
    useRouter().push({
        path: getLocalPath(path),
        replace: true, // 默认不生成历史记录  
        ...oConfig,
    });
}


// ↓ 进入某个厅的方法  
export const fnGoIntoOneHall = (
    oOneHall,
    oConfig={},
)=>{
    if (!oOneHall.enabled) {
        showNegativeNotify({
            i18n: 'goldenFlower.hallDisabled',
        }); 
        return;
    }
    if (oOneHall['accessable'] == false){
        showNegativeNotify({
            i18n: 'goldenFlower.lowBalance',
        }); 
        return;
    }
    const path = `/casino/jisuzhajinhuaGame/indoor/${oOneHall.tableNum}`; 
    useRouter().push({
        path: getLocalPath(path),
        query: {
            name: oOneHall.displayName || oOneHall.name,
        },
        // replace: true, // 不生成历史记录
        ...oConfig,
    });
}


// ↓ 大厅列表 - 静态数据版本
export const getHallsList = ()=>{
    if (import.meta.server) return []; 
    
    // 返回静态大厅数据，不再依赖API
    return [
        {
            intOrder: 1,
            name: 'trial',
            displayName: '体验厅',
            tableNum: 1,
            minimumEntry: 0.1,
            minBet: 0.1,
            maxBet: 10,
            accessable: true,
            enabled: true,
            betable: true,
        },
        {
            intOrder: 2,
            name: 'premium',
            displayName: '娱乐厅',
            tableNum: 2,
            minimumEntry: 1,
            minBet: 1,
            maxBet: 100,
            accessable: true,
            enabled: true,
            betable: true,
        },
        {
            intOrder: 3,
            name: 'rick',
            displayName: '旗舰厅',
            tableNum: 3,
            minimumEntry: 10,
            minBet: 10,
            maxBet: 1000,
            accessable: true,
            enabled: true,
            betable: true,
        },
        {
            intOrder: 4,
            name: 'vip',
            displayName: '富豪厅',
            tableNum: 4,
            minimumEntry: 100,
            minBet: 100,
            maxBet: 10000,
            accessable: true,
            enabled: true,
            betable: true,
        },
    ];
}

export const initSeats = (): Seat[] => {
    return Array(7)
        .fill(1)
        .map((_, idx) => ({
            occupied: false,
            player_id: 0,
            position: idx,
        }));
};

// export const creatPlayer = () => {
//     return {
//         id: null,
//         name: '',
//         chips: '',
//         isWatchCards: false, // 是否看牌
//         isShowCard: false, // 是否亮牌
//         cards: [],
//         cardType: -1,
//         totalBet: 0,
//         inGame: false, // 表示是否在游戏中（有可能玩家入场了，但未参赛，仅旁观）
//         isQuit: false,
//         isLose: false,
//         avatar: '',
//         lv: 1,
//     };
// };

/**
 * 获取下一位玩家
 * 
 * @param arrangedPlayers 已经排好相对位置的玩家数组
 * @param currentId 当前玩家的 id
 * @returns 下一位玩家对象
 */
export function getNextPlayer<T extends { id: number }>(
    arrangedPlayers: T[],
    currentId: number
): T | null {
    const index = arrangedPlayers.findIndex(p => p.id === currentId);
    if (index === -1) return null;

    const nextIndex = (index + 1) % arrangedPlayers.length;
    return arrangedPlayers[nextIndex];
}

/**
 * 旋转玩家数组，确保自己（isSelf=true）永远在数组最后一个位置
 * 其他玩家的顺序保持不变
 */
export function rotateAndMapPlayers(players: Player[]): Player[] {
    const selfIndex = players.findIndex(p => p?.isSelf);
    if (selfIndex === -1) return players;

    // 旋转数组，让自己在最后
    const rotated = players.slice(selfIndex + 1).concat(players.slice(0, selfIndex + 1));

    // 顺序：对手依次 L,R,L,R,L,R，自身在最后
    // rotated 长度为 7，self 固定在 index 6
    const map = [0, 1, 2, 3, 4, 5, 6];

    // 根据映射生成新数组
    return map.map(i => rotated[i]);
}



/**
 * ↑ 在当前游戏有用的方法
 * | -------------------------------------------------------------------------------------
 * ↓ 疑似需要清除的方法，逐步清理 
 */


export const fnOperateHistoryDetail = (
    oHistory, 
)=>{
    // const {t: $tFn, locale} = useNuxtApp().$i18n;
    const {
        playerId,
        groupId,
        senderInfo,
        history_detail_list,
    } = oHistory;
    if (!playerId){
        console.error('红包游戏缺失 playerId', playerId); 
    }
    const aAmountList = history_detail_list.map(cur=>{
        return cur.win_amount;
    });
    senderInfo.timestamp *= 1000;
    // ↓ 最大获奖金额 
    const iBiggestAmount = Math.max(...aAmountList); 
    // ↓ 追加抢包信息 
    const history_detail_list_new = history_detail_list.map(cur => {
        const {win_amount, winAmountAfterTax} = cur;
        const thisOne = {
            ...cur,
            timestamp: cur.timestamp * 1000,
            isChampion: (win_amount > 0) && (win_amount == iBiggestAmount), 
            // ↓ 赢钱是才有前值 || 输时取后值（负数） 
            // ↓ 用于游戏历史的详情窗口 
            winAmountFinal: winAmountAfterTax || win_amount,
        };
        return thisOne;
    });
    const oResult = { // 先声明，后赋值 
        _id: '',
        timestamp: 0,
        "amount": 0,
        "winAmount": 0,
        "multi": 0,
        "currency": oHistory.currency,
        senderInfo,
        history_detail_list: history_detail_list_new, 
        "user": {
            "_id": 0,
            "avatar": "",
            "lvl": 1,
            "name": "",
        },
    };

    if (String(senderInfo.send_user_id) == String(playerId)){ // 当前用户是发包人  
        Object.assign(oResult, {
            _id: groupId,
            timestamp: senderInfo.timestamp,
            amount: senderInfo.amount,
            winAmount: senderInfo.winAmount,
            multi: senderInfo.winAmount > 0 ? senderInfo.multi : 0, 
            user: {
                // "lvl": senderInfo.lvl || 1,
                "_id": senderInfo.send_user_id,
                "avatar": senderInfo.send_user_avatar,
                "name": senderInfo.send_name,
            },
        }); 
    }else{
        const oSelf = history_detail_list_new.find(cur => { 
            return playerId == cur.user_id; 
        });
        Object.assign(oResult, {
            _id: oSelf.order_id,
            timestamp: oSelf.timestamp,
            winAmount: oSelf.win_amount,
            user: {
                "_id": oSelf.user_id,
                "avatar": oSelf.user_avatar,
                "name": oSelf.user_name,
            },
        }); 
    }
    return oResult;
};

